import GridinQuestion from './GridinQuestion';
export default GridinQuestion;